import styled from 'styled-components';

export const AddToCartMaternity = styled.button`
  width: 100%;
  display: block;
  height: 2rem;
  text-transform: uppercase;
  margin: 0 auto 0;
  position: relative;
  padding: 2px;
  overflow: hidden;
  font-weight: bold;
  border: ${(props) => (props.verm ? 'none' : '1px solid rgba(0, 0, 0, 0.8)')};
  background-color: ${(props) => (props.verm ? 'rgb(239,78,94)' : '#fff')};
  color: ${(props) => (props.verm ? '#fff' : 'rgb(20,0,0,0.8)')};
  border-radius: 5px;
  font-family: Montserrat;
  @media (min-width: 720px) {
    width: 18vw;
    height: 2.5rem;
    cursor: pointer;
  }
`;

export const ButtonPriceContainer = styled.div`
  margin-top: auto;
`;
